<template>
    <div>
        <div class="cta-box">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-6 col-12">
                    <!-- Cta Box Item Start -->
                    <div class="cta-box-item wow fadeInUp">
                        <div class="icon-box">
                            <img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2Ficon-cta-phone.svg?alt=media&token=1b878072-9254-462c-ab48-8246239aba7b" alt="">
                        </div>
                        <div class="cta-box-content">
                            <h3>necesitas atención personalizada ?</h3>
                            <p>Llamanos : +52 1 993 219 7400</p>
                        </div>
                    </div>
                </div>
                <!-- Cta Box Item End -->

                <!-- Cta Box Item Start -->
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="cta-box-item wow fadeInUp" data-wow-delay="0.25s">
                        <div class="icon-box">
                            <img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2Ficon-cta-time.svg?alt=media&token=6a2ba9ca-1f3b-4fbd-ba4e-a8dfdee5f6d4" alt="">
                        </div>
                        <div class="cta-box-content">
                            <h3>Horario de trabajo</h3>
                            <p>Lun a Sab 9:00AM to 8:00PM</p>
                        </div>
                    </div>
                </div>
                <!-- Cta Box Item End -->

                <div class="col-lg-4 col-md-12 col-12">
                    <!-- Cta Box Btn Start -->
                    <div class="cta-box-btn wow fadeInUp" data-wow-delay="0.5s">
                        <a href="https://wa.link/kkyua5" class="btn-default btn-highlighted">agendar cita</a>
                    </div>
                    <!-- Cta Box Btn End -->
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
 
};
</script>
